import React from 'react'
import { useTranslation } from 'react-i18next'
import { PostMetric } from 'schemas/PostMetricSchema'
import DeletedPost from 'components/visualization/SoundbiteFrame/DeletedPost'
import { useDateTimeString } from '../hooks'

interface DeletedPostProps {
  data: PostMetric[]
  /**
   * for test id
   */
  serialNumber: number
}
const DeletedPosts = ({ data, serialNumber }: DeletedPostProps) => {
  const { t } = useTranslation()

  const numberOfPosts = data.length

  const dateTimeString = useDateTimeString(data)

  return (
    <DeletedPost
      serialNumber={serialNumber}
      content={t('postDeletedByAuthor', { count: numberOfPosts })}
      date={dateTimeString}
    />
  )
}

export default DeletedPosts
